import {Component, Input, OnInit} from "@angular/core";

@Component({
    selector: "fui-video",
    templateUrl: "./video.component.html",
    styleUrls: ["./video.component.scss"]
})
export class FUIVideoComponent implements OnInit {
    @Input() video: string;

    constructor() {
    }

    ngOnInit() {
    }
}
